"use strict";

import _ from "underscore";

export default class WantedController {
  /*@ngInject*/
  constructor(ElasticAPI, $location) {
    this.ElasticAPI = ElasticAPI;
    this.results = [];
    this.enabled = false;
    this._query = null;
    this.selectedPos = [];

    let params = $location.search();
    this.lang =
      params && params.lang && (params.lang == "fr" || params.lang == "en")
        ? params.lang
        : "fr";

    // this.query = 'jean';
    // this.searchWanted();
  }

  searchWantedKeyDown() {
    if (event.keyCode == 13 && this.query && this.query.length > 1) {
      this.searchWanted();
    }
  }

  selectWanted(pos) {
    //this.selectedPos.push(pos);
    this.selectedPos = [pos];
  }

  isSelected(pos) {
    // return true
    return this.selectedPos.indexOf(pos) != -1;
  }

  searchWanted() {
    this.results = null;
    this.enabled = false;
    this._query = this.query;
    this.selectedPos = [];
    let that = this;
    if (this.query && this.query.length > 1) {
      return this.ElasticAPI.searchWanted(
        {
          name: this.query,
        },
        function (results) {
          return results;
        }
      ).$promise.then(function (results) {
        that.results = JSON.parse(JSON.stringify(results));
        // console.log(that.results);
        that.enabled = true;
        return;
      });
    } else {
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/wanted/wanted.controller.js